import type { ColumnId } from '@/types/enums/column-id'

import holdingsColumnDefinitions from '@/components/molecules/holdings-table/columns'
import {
  type ColumnState,
  FilterPaneState,
  type HoldingListConfig,
  ViewType,
} from '@/types/schema/page-configs/holding-list'

export const defaultHoldingListConfig: HoldingListConfig = {
  filterPaneState: FilterPaneState.Closed,
  viewType: ViewType.Standard,
  columnState: getDefaultColumnState(),
}

function getDefaultColumnState(): ColumnState[] {
  return Array.from(holdingsColumnDefinitions.values()).map((columnDef) => {
    return {
      colId: columnDef.colId as ColumnId,
      displayName: columnDef.headerName || '',
      visible: !columnDef.hide,
      width: columnDef.width,
    }
  })
}
